/**
 * @returns a camelCase version of the input string
 *
 * source: https://stackoverflow.com/questions/2970525/converting-a-string-with-spaces-into-camel-case
 */
export const camelCase = (text: string | null | undefined): string => {
  if (!text) {
    return ''
  }

  const a = text?.replace(/[-_\s.]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''))
  return a?.substring(0, 1).toLowerCase() + a?.substring(1)
}

/**
 * @returns title case of the string
 *
 * source: https://stackoverflow.com/questions/196972/convert-string-to-title-case-with-javascript
 */
export const titleCase = (text: string | null | undefined): string => {
  if (!text) {
    return ''
  }

  return text
    .split(' ')
    .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
    .join(' ')
}
